import React from "react";

/**
 * Defines the "Not Found" page that is displayed for any unmatched route.
 *
 * You will not need to make changes to this file.
 *
 * @returns {JSX.Element}
 */
function NotFound() {
  return (
    <div className="NotFound">
      <h1>Not Found</h1>
    </div>
  );
}

export default NotFound;
